// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main-body.central[data-v-223957cf] {
  padding: 0 16px 18px 16px;
}
.main-body.central[data-v-223957cf] .main-content-container {
  margin: 20px auto 0 auto;
  flex-basis: auto !important;
  background: var(--content-container-bgcolor);
  border-radius: 4px;
  box-shadow: rgba(0, 0, 0, 0.1) 0 1px 3px 0, rgba(0, 0, 0, 0.15) 0 1px 3px 1px;
}
.main-body.central[data-v-223957cf] .main-content-container .main-content-container-header {
  margin-bottom: 0px;
  padding-top: 12px;
  padding-left: 12px;
  font-size: 16px;
  font-weight: 600;
}
.main-body.central[data-v-223957cf] .main-content-container .main-content-container-main {
  background: inherit;
  box-shadow: none;
  margin-bottom: 0px;
}
.main-body.central .session-item[data-v-223957cf] {
  height: 74px !important;
}
.main-body.central .session-item .item-header[data-v-223957cf] {
  font-size: 16px !important;
  color: initial !important;
}
.main-body.central .session-item .item-title[data-v-223957cf] {
  font-size: 14px !important;
}
.main-body.central .items-list .after-section[data-v-223957cf] {
  display: flex;
  flex-direction: column;
}
.main-body.central .items-list .after-section .remove-sign[data-v-223957cf] {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  height: 2em;
  cursor: pointer;
}
.main-body.central .items-list .after-section .remove-sign i[data-v-223957cf] {
  display: flex;
  align-items: flex-end;
  justify-content: center;
  height: 1.5em;
  width: 1.6em;
  font-size: 1.5em;
}
`, "",{"version":3,"sources":["webpack://./js/app/components/main/body/MainContentSessions.vue"],"names":[],"mappings":"AAAA;EACE,yBAAyB;AAC3B;AACA;EACE,wBAAwB;EACxB,2BAA2B;EAC3B,4CAA4C;EAC5C,kBAAkB;EAClB,6EAA6E;AAC/E;AACA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,0BAA0B;EAC1B,yBAAyB;AAC3B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,WAAW;EACX,eAAe;AACjB;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,uBAAuB;EACvB,aAAa;EACb,YAAY;EACZ,gBAAgB;AAClB","sourcesContent":[".main-body.central[data-v-223957cf] {\n  padding: 0 16px 18px 16px;\n}\n.main-body.central[data-v-223957cf] .main-content-container {\n  margin: 20px auto 0 auto;\n  flex-basis: auto !important;\n  background: var(--content-container-bgcolor);\n  border-radius: 4px;\n  box-shadow: rgba(0, 0, 0, 0.1) 0 1px 3px 0, rgba(0, 0, 0, 0.15) 0 1px 3px 1px;\n}\n.main-body.central[data-v-223957cf] .main-content-container .main-content-container-header {\n  margin-bottom: 0px;\n  padding-top: 12px;\n  padding-left: 12px;\n  font-size: 16px;\n  font-weight: 600;\n}\n.main-body.central[data-v-223957cf] .main-content-container .main-content-container-main {\n  background: inherit;\n  box-shadow: none;\n  margin-bottom: 0px;\n}\n.main-body.central .session-item[data-v-223957cf] {\n  height: 74px !important;\n}\n.main-body.central .session-item .item-header[data-v-223957cf] {\n  font-size: 16px !important;\n  color: initial !important;\n}\n.main-body.central .session-item .item-title[data-v-223957cf] {\n  font-size: 14px !important;\n}\n.main-body.central .items-list .after-section[data-v-223957cf] {\n  display: flex;\n  flex-direction: column;\n}\n.main-body.central .items-list .after-section .remove-sign[data-v-223957cf] {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  height: 2em;\n  cursor: pointer;\n}\n.main-body.central .items-list .after-section .remove-sign i[data-v-223957cf] {\n  display: flex;\n  align-items: flex-end;\n  justify-content: center;\n  height: 1.5em;\n  width: 1.6em;\n  font-size: 1.5em;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
